import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { downloadFileFromUrl } from '../../../../utils/helpers/download'
import { genFormattedColumn } from '../../../../components/tables/Table'
import { templatesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useTemplateRecords } from '../_load/TemplateRecordLoader'
import FlexDataTable from '../../../../components/tables/FlexDataTable'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import ListCounter from '../../../../components/helpers/ListCounter'

const TemplateRecordHistoryTable = () => {
  const { t } = useTranslation()
  const data = useTemplateRecords()
  const { data: entity } = useCurrentModal()

  const columns = [
    {
      title: 'Documento ',
      headerSideContent: (
        <>
          <ListCounter
            client={templatesClient}
            entity="templateRecords"
            filterName="TemplateRecordFilter"
            filters={{ entities: [entity] }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: ['template', 'name'],
      sortIndex: false,
      flex: 4,
      render: genFormattedColumn(capitalizeAllIfLower)
    },
    {
      title: 'Data',
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      render: genFormattedColumn(formatDate('DD/MM/YYYY HH:mm'))
    },
    {
      title: `Download `,
      dataIndex: ['document', 'src'],
      sortIndex: false,
      flex: 1,
      render: (value, record) => (
        <FlexGrid justify="center">
          <Icon onClick={() => downloadFileFromUrl(value)} name="BsDownload" />
        </FlexGrid>
      )
    }
  ]

  //double data table
  return <FlexDataTable rowKey="id" columns={columns} size="small" data={data} disableMultiSelect />
}

export default TemplateRecordHistoryTable
